'use client';

import { useTranslations } from 'next-intl';
import { FeatureDetailContent } from './FeatureDetailContent';
import {
    Ticket,
    MessageSquare,
    Clock,
    CheckCircle,
    Mail,
    HeadphonesIcon
} from 'lucide-react';

export function TicketSystemContent() {
    const t = useTranslations('ticketSystem');

    const features = [
        {
            icon: Ticket,
            title: t('features.step1.title'),
            description: t('features.step1.description'),
        },
        {
            icon: Clock,
            title: t('features.step2.title'),
            description: t('features.step2.description'),
        },
        {
            icon: MessageSquare,
            title: t('features.step3.title'),
            description: t('features.step3.description'),
        },
        {
            icon: CheckCircle,
            title: t('features.step4.title'),
            description: t('features.step4.description'),
        },
        {
            icon: Mail,
            title: t('features.step5.title'),
            description: t('features.step5.description'),
        },
        {
            icon: HeadphonesIcon,
            title: t('features.step6.title'),
            description: t('features.step6.description'),
        },
    ];

    // Get benefits list from translations, ensuring it's always an array
    const benefitsRaw = t.raw('benefits.list');
    const benefits = Array.isArray(benefitsRaw) ? benefitsRaw : (benefitsRaw ? [benefitsRaw] : []);

    return (
        <FeatureDetailContent
            pageKey="ticket-system"
            translationNamespace="ticketSystem"
            features={features}
            benefits={benefits}
            ctaIcon={Ticket}
            showWhatIsBitcoin={false}
            introImageSrc="/images/features/ticket.webp"
            introImageAlt={t('intro.imageAlt') || 'Ticket System in MLM Software'}
            introParagraphKeys={['paragraph2', 'paragraph3']}
            introSectionHeadingPage="ticket-system"
            introSectionHeadingTitle={t('intro.sectionHeadingTitle') || 'About Ticket System'}
            introSectionHeadingPill={t('intro.sectionHeadingPill') || 'Ticket System'}
            useLocaleContent={true}
        />
    );
}

